import servise from '@/router/axios'

export const updateCheckedProduct = (params) => {
  return servise({
    url: '/checked/product',
    method: 'get',
    params
  })
}

export const setWebCpsProduct = (data) => {
  return servise({
    url: '/webCpsProduct/set',
    method: 'post',
    data
  })
}
export const setWebCpsProductAdStatus = (data) => {
  return servise({
    url: '/webCpsProduct/advertisingStatus',
    method: 'post',
    data
  })
}

// 商品转链接接口
export const createProductLink = (data) => {
  return servise({
    url: '/product/link',
    method: 'post',
    data
  })
}

// 保存商品链接信息
export const saveProductLink = (data) => {
  return servise({
    url: '/webCpsProduct/saveLink',
    method: 'post',
    data
  })
}
